import { ChrThemeProvider } from '@chr/eds-react';
import { getConfiguration } from '@chr/common-web-ui-configuration';
import { render } from 'react-dom';
import { App } from './App';
import { OnlineProvider } from '@chr/navisphereonline-shared-components';
import { initializeDataDog } from '@/common/utilities/datadog';
import { OnlineTranslationProvider, loadMicrositeLanguage } from '@chr/online-shared-ui-localizations';
import { getUserDetail } from '@chr/online-shared-microsite-core';
import * as FullStory from '@/common/components/full-story/FullStory'

import './index.scss';
import { ChrLdProvider } from '@chr/common-launchdarkly';

export const index = (async () => {
  try {
    const config = await getConfiguration<AppConfig>();

    loadMicrositeLanguage();
    initializeDataDog(config);
    FullStory.initialize();

    let userProfile;
    if (config.environment && config.environment != 'local') {
      try {
        userProfile = await getUserDetail();
        if (userProfile) {
          const userData = {
            displayName: userProfile.userId?.toString(),
            companyName: userProfile.primaryBusinessLine,
            carrierCode: userProfile.primaryCustomerCode,
            userName: userProfile.primaryCustomerCode,
            VisibilityBookingDetailPage: true
          };
          userProfile.userId && FS.identify(userProfile.userId.toString(), userData);
        }
      } catch {
        // Do not block loading for a FullStory error
      }
    }

    render(
      <OnlineTranslationProvider>
        <ChrThemeProvider theme="Unstable Single UI">
          <OnlineProvider appConfig={config}>
            <FullStory.IdentifyUser />
            <ChrLdProvider
              envKey={config.launchDarklyClientId}
              context={{ kind: 'user', key: userProfile?.userId?.toString() ?? 'anonymous' }}
            >
              <App config={config} />
            </ChrLdProvider>
          </OnlineProvider>
        </ChrThemeProvider>
      </OnlineTranslationProvider>,
      document.getElementById('root')
    );
  } catch (e) {
    // This is an error that can be thrown when ES modules aren't natively supported.
    // There is a pollyfill in place so we just swallow this error.
    // Temporary until we find a better error handling solution
    if (e instanceof Error && e.message.indexOf('Error resolving module') > -1) {
      return;
    }

    console.error(e);
    render(<h1>Error loading application</h1>, document.getElementById('root'));
  }
})();
